import defaultTrainerFormValidations from 'common/validations/form/defaultTrainer';

const validateEditTrainerForm = (values) => {
  const errors = defaultTrainerFormValidations(values);

  return errors;
};

export default validateEditTrainerForm;
